import styled from "@emotion/styled";
import type { Theme } from "@mui/material/styles";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import NotificationIcon from "src/images/Icons/newIcons/notifications/notification.svg";

import { htmlFormatter } from "../../../formatters/htmlFormatter";
import type { NotificationData } from "./List";
import { NotificationStatus } from "./List";
import { Notification } from "./NotificationItem";

export const NotificationDate = styled("div")<{ status: string }>`
  color: ${({ theme, status }) =>
		status === NotificationStatus.waiting
			? (theme as Theme).palette.primary.main
			: "inherit"};
  font-size: 10px;
  font-weight: ${({ status }) =>
		status === NotificationStatus.waiting ? "bold" : "normal"};
`;

interface LinkNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
}

export function LinkNotification({
	notification,
	removeNotification,
}: LinkNotificationProps) {
	const { t } = useTranslation();
	const redirect = async () => {
		window.open(notification.url, "_blank");
	};

	return (
		<Notification
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={NotificationIcon}
			Primary={<div>{htmlFormatter(notification.message)}</div>}
			Secondary={
				<NotificationDate status={notification.status}>
					{t("notifications.expired", {
						date: dayjs(notification.endDate).format("YYYY.MM.DD"),
					})}
				</NotificationDate>
			}
			disabledActionsList={["stopSubscribe"]}
		/>
	);
}
